import numFormat from 'number-format'
import moment from 'moment'

/// Check for Empty Object
export function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

export function removeArray(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

export function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; 
};

export function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}

export function hasClass2(element, className) {
    return element.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className);
}


export function toggleClass(el, className) {
    var pattern = new RegExp('(^|\\s)' + className + '(\\s|$)');
    if (pattern.test(el.className)) {
        el.className = el.className.replace(pattern, ' ');
    } else {
        el.className += ' ' + className;
    }
};



export function formatCurrency(Amount, format, code) {
    // console.log(format)
    //console.log(numFormat(format, Amount))
    var DecimalSeparator = Number("1.2").toLocaleString().substr(1, 1);
    var AmountWithCommas = Amount.toLocaleString();
    var arParts = String(AmountWithCommas).split(DecimalSeparator);
    var intPart = arParts[0];
    var decPart = (arParts.length > 1 ? arParts[1] : '');
    decPart = (decPart + '00').substr(0, 2);
    if (!code) {
        code = 'NGN '
    }
    if (format) {
        return numFormat(format, Amount)
    }

    return code + ' ' + intPart + DecimalSeparator + decPart;
}

export function checkComponentValidation(validations) {
    //console.log((validations))
    //console.log(Object.values(validations))
    const validation = {}
    var values = Object.values(validations);
    for (let o of values) {
        if (o.isValid === false) {
            return o;
        }
        else {
            return { isValid: true, message: "" }
        }
    }
}


export function clearSessionStorage() {

}

export function GetTimeInWords(value) {
    if (value <= 0) {
        return "0 secs";
    }
    var diff = moment.duration(value, 'minutes');
    if (diff.days() > 1) {
        return diff.days() + " days"
    }
    if (diff.days() === 1) {
        return diff.days() + " day"
    }
    if (diff.hours() > 1) {
        return diff.hours() + " hours"
    }
    if (diff.hours() === 1) {
        return diff.hours() + " hour"
    }
    if (diff.minutes() > 1) {
        return diff.minutes() + " mins"
    }
    if (diff.minutes() === 1) {
        return diff.minutes() + " min"
    }
    if (diff.minutes() < 1) {
        return "1 min"
    }
    return "0 secs";
}

export function titleCase(str) {
    return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
}


export function toTitleCase(str) {
    return str.toLowerCase().split(' ').map(function (word) {
        return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const SyncColors = {
    names: {
        aqua: "#00ffff",
        black: "#000000",
        blue: "#0000ff",
        brown: "#a52a2a",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgrey: "#a9a9a9",
        darkgreen: "#006400",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkviolet: "#9400d3",
        fuchsia: "#ff00ff",
        gold: "#ffd700",
        green: "#008000",
        indigo: "#4b0082",
        khaki: "#f0e68c",
        lightblue: "#add8e6",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lime: "#00ff00",
        magenta: "#ff00ff",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        pink: "#ffc0cb",
        purple: "#800080",
        violet: "#800080",
        red: "#ff0000",
        silver: "#c0c0c0",
    },
    random: () => {
        var result;
        var count = 0;
        for (var prop in SyncColors.names)
            if (Math.random() < 1/++count)
               result = prop;
               console.log(result)
               //console.log(SyncColors.names.length)
        return { name: result, rgb: SyncColors.names[result]};
    },
    getColor: (value = 0) => {
        if (value <= 0)
        {
            return { name: "green", rgb: SyncColors.names.green};
        }
        let colorKeys = Object.keys(SyncColors.names)
        if (value < colorKeys.length)
        {
            let color = colorKeys[value]
            return { name: color, rgb: SyncColors.names[color]};
        }
      
        if (value >= colorKeys.length)
        {
            var i = value;
            do{
                i = (i % colorKeys.length)
            } while( i > colorKeys.length)

            let color = colorKeys[i]
            return { name: color, rgb: SyncColors.names[color]};
        }

        return { name: "red", rgb: SyncColors.names.red};
    },
    getColorFromString: (stringValue = "") => {
        var value = Math.abs(hashCode(stringValue));
        //console.log(value.toString().length)
        if (value.toString().length > 5)
        {
            value = parseInt(value.toString().substr(0, 2))
        }
        if (value <= 0)
        {
            return { name: "green", rgb: SyncColors.names.green};
        }
        let colorKeys = Object.keys(SyncColors.names)
        if (value < colorKeys.length)
        {
            let color = colorKeys[value]
            return { name: color, rgb: SyncColors.names[color]};
        }
      
        if (value >= colorKeys.length)
        {
            var i = value;
            do{
                i = (i % colorKeys.length)
            } while( i > colorKeys.length)

            let color = colorKeys[i]
            return { name: color, rgb: SyncColors.names[color]};
        }

        return { name: "red", rgb: SyncColors.names.red};
    }
}

function getlength(number) {
    return number.toString().length;
}

export function hashCode(s) {
    for(var i = 0, h = 0; i < s.length; i++)
        h = Math.imul(31, h) + s.charCodeAt(i) | 0;
    return h;
}


